module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av424-dbf20ca44b5c1f415cbcade893c8ed01.jpg";